import { atom } from 'recoil'

import { RecoilKeys } from '../../../constants/RcoilKeys'

export const currentBreadcrumb = atom({
  default: '',
  key: RecoilKeys.currentBreadcrumb,
})
